export const en = {
  "helmet": {
    "title": "Accounting and Management Software for Condominium Juristic Persons, Housing Estate Juristic Persons, and Office Buildings | Silverman Application",
    "meta_description": "Silverman is accounting and management software for juristic entities of condominiums, residential estates, and office buildings. It aims to facilitate the convenience in issuing invoices, receipts, and project parcel notifications. It is easy to use, secure, and stores data on the cloud.",
    "meta_keyword": "Silverman, accounting software, accounting software for condominium juristic persons, accounting software for residential estates, corporate management software, condominium parcel notification software."
  },
  "header": {
    "background_image": "/images/becomePartner/bg-image.jpg",
    "title": "Become our partner",
    "subtitle": "We are ready to team up and become your partner. Join us in the journey to the better property management standard. We will help you improve services to increase satisfaction for residents."
  },
  "body": {
    "content": "For over 3 years, Silverman cloud platform has made the property management tasks run more effectively and fulfills residents’ happiness. Silverman’s comprehensive system has been trusted by many house committees and property management companies. We are still going strong and looking forward to collaborating with new partners to bring the most efficient property management and best service to every housing estate and condominium. "
  },
  "info_title": "Benefits of partnering",
  "info_subtitle": "with Silverman",
  "info_list": [
    {
      "image": "/images/becomePartner/info-icons/services.webp",
      "content": "Enable you to reach your customers and to offer new service and promotions on our platform. "
    },
    {
      "image": "/images/becomePartner/info-icons/support.webp",
      "content": "`Gain access to our network of business partners. We will provide marketing support to promote your business.`"
    },
    {
      "image": "/images/becomePartner/info-icons/collaboration.webp",
      "content": "Collaborate with our team to develop new technologies that meet your needs."
    },
    {
      "image": "/images/becomePartner/info-icons/increase.webp",
      "content": "Expand your opportunities in increasing marketing budgets. Co-operates marketing plan with us."
    }
  ]
}

export const th = {
  "helmet": {
    "title": "โปรแกรมบัญชีและบริหารงานสำหรับ นิติบุคคลอาคารชุด นิติบุคคลหมู่บ้าน อาคารสำนักงาน | Silverman Application",
    "meta_description": "Silverman เป็นโปรแกรมบัญชีและบริหารงานสำหรับนิติบุคคลอาคารชุด คอนโด หมู่บ้าน อาคารสำนักงาน เพื่อความสะดวกในการออกใบแจ้งหนี้ ใบเสร็จ และแจ้งพัสดุของโครงการ ใช้งานง่ายปลอดภัย เก็บข้อมูลบน Cloud",
    "meta_keyword": "Silverman, โปรแกรมบัญชี, โปรแกรมบัญชีสำหรับนิติบุคคลอาคารชุด, โปรแแกรมบัญชีสำหรับหมู่บ้าน,โปรแกรมบริหารงานนิติบุคคล, โปรแกรมแจ้งพัสดุสำหรับคอนโด"
  },
  "header": {
    "background_image": "/images/becomePartner/bg-image.jpg",
    "title": "เป็นพันธมิตรกับเรา",
    "subtitle": "เราพร้อมเปิดรับคู่ค้าและพันธมิตรทางธุรกิจ ที่พร้อมเปลี่ยนแปลง\nการบริหารจัดการนิติบุคคลที่ยิ่งใหญ่ไปด้วยกัน พร้อมดูแลลูกบ้านให้ประทับใจมากที่สุด"
  },
  "body": {
    "content": "กว่า 3 ปีที่ Silverman ได้รับความไว้วางใจจากคณะกรรมการบริหารโครงการและนิติบุคคลของโครงการต่างๆ ขับเคลื่อนนิติบุคคลผ่านระบบ Silverman platform on cloud และงานบริหารจัดการลูกบ้านเพื่อเติมความสุขให้ลูกบ้านมากที่สุด แต่หากเรายังไม่หยุดแค่นั้น เราพร้อมที่จะต้อนรับพันธมิตรใหม่ๆเสมอ เพื่อให้งานบริหารของนิติบุคคลและบริการลูกบ้านให้ดีที่สุด"
  },
  "info_title": "สิทธิประโยชน์ที่คุณจะได้",
  "info_subtitle": " จากการเป็นคู่ค้าและพันธมิตรกับเรา",
  "info_list": [
    {
      "image": "/images/becomePartner/info-icons/services.webp",
      "content": "รับสิทธิพิเศษในการขายสินค้า \n โปรโมชัน \n และข้อเสนอพิเศษที่เป็นประโยชน์ต่อธุรกิจคุณ"
    },
    {
      "image": "/images/becomePartner/info-icons/support.webp",
      "content": "เพิ่มโอกาสในการติดต่อคู่ค้าทางธุรกิจใหม่ๆโดยจะได้รับการสนับสนุน \n ทางการตลาดและบริการเพื่อโปรโมตธุรกิจของคุณ"
    },
    {
      "image": "/images/becomePartner/info-icons/collaboration.webp",
      "content": "เพิ่มโอกาสในการร่วมพัฒนาเทคโนโลยีใหม่ๆ และทำโปรเจคร่วมกัน"
    },
    {
      "image": "/images/becomePartner/info-icons/increase.webp",
      "content": "เพิ่มโอกาสในการเพิ่มเงินทุนทางการตลาด และทำแผนการตลาดร่วมกัน"
    }
  ]
}